// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4e-0";
export var eligibilityCardNotEligible = "_4e-1";